import { createAction } from '@ngrx/store';
import { baseProps } from 'projects/shared/src/lib/core/store/actions-base';
import {
  AssetDetailsForSidebarResponseDto,
  Comment,
  CyberAsset,
  CyberAssetsFilterOption,
  CyberAssetsFilters,
  Pagination,
} from 'projects/shared/src/lib/core/interfaces';

export const fetchCyberAssets = createAction(
  '[@diso/cyber-assets] fetchCyberAssets',
  baseProps<{
    page: number;
    pageSize: number;
    filters?: CyberAssetsFilters;
    /** True when this fetch was triggered by an added/removed/changed filter (vs. pagination). */
    filtersChanged?: boolean;
  }>(),
);

export const fetchCyberAssetsSuccess = createAction(
  '[@diso/cyber-assets] fetchCyberAssetsSuccess',
  baseProps<{
    pagination: Pagination<CyberAsset, 'assets'>;
  }>(),
);

export const fetchCyberAssetsFailure = createAction(
  '[@diso/cyber-assets] fetchCyberAssetsFailure',
);

export const fetchAssetsFilterOptions = createAction(
  '[@diso/cyber-assets] fetchAssetsFilterOptions',
  baseProps<{
    filters?: CyberAssetsFilters;
  }>(),
);

export const fetchAssetsFilterOptionsSuccess = createAction(
  '[@diso/cyber-assets] fetchAssetsFilterOptionsSuccess',
  baseProps<{
    filterOptions: CyberAssetsFilterOption;
  }>(),
);

export const fetchAssetsFilterOptionsFailure = createAction(
  '[@diso/cyber-assets] fetchAssetsFilterOptionsFailure',
);

export const fetchAssetDetailsForSidebar = createAction(
  '[@diso/cyber-assets] fetchAssetDetailsForSidebar',
  baseProps<{ assetId: string }>(),
);

export const fetchAssetDetailsForSidebarSuccess = createAction(
  '[@diso/cyber-assets] fetchAssetDetailsForSidebarSuccess',
  baseProps<{ details: AssetDetailsForSidebarResponseDto }>(),
);

export const fetchAssetDetailsForSidebarFailure = createAction(
  '[@diso/cyber-assets] fetchAssetDetailsForSidebarFailure',
);

export const clearAssetDetailsSidebar = createAction(
  '[@diso/cyber-assets] clearAssetDetailsSidebar',
);

export const addAssetSidebarComment = createAction(
  '[@diso/cyber-assets] addAssetSidebarComment',
  baseProps<{ assetId: string; commentText: string }>(),
);

export const addAssetSidebarCommentSuccess = createAction(
  '[@diso/cyber-assets] addAssetSidebarCommentSuccess',
  baseProps<{ comment: Comment }>(),
);

export const setAssetDetailsCommentPending = createAction(
  '[@diso/cyber-assets] setAssetDetailsCommentPending',
  baseProps<{ pending: boolean }>(),
);

export const setAssetDetailsCommentFailed = createAction(
  '[@diso/cyber-assets] setAssetDetailsCommentFailed',
  baseProps<{ failed: boolean }>(),
);

export const setNeedUpdate = createAction(
  '[@diso/cyber-assets] setNeedUpdate',
  baseProps<{ needUpdate: boolean }>(),
);
